import { z } from 'zod'

/** Shared contact-form schema used by the client form and the API route. */
export const contactSchema = z.object({
    name: z.string().trim().min(2).max(120),
    company: z.string().trim().max(160).optional().or(z.literal('')),
    email: z.string().trim().email().max(200),
    phone: z.string().trim().max(60).optional().or(z.literal('')),
    message: z.string().trim().min(10).max(5000),
    // Honeypot: must stay empty. Bots tend to fill every field.
    website: z.string().max(0).optional().or(z.literal(''))
})

export type ContactInput = z.infer<typeof contactSchema>
